import {
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  input,
  signal,
  type TemplateRef,
} from '@angular/core';

import { NgpDialogTrigger } from 'ng-primitives/dialog';

@Directive({
  selector: 'button[mlDialogTrigger]',
  hostDirectives: [
    {
      directive: NgpDialogTrigger,
      inputs: ['ngpDialogTrigger: mlDialogTrigger'],
    },
  ],
  exportAs: 'mlDialogTrigger',
})
export class DialogTriggerDirective {
  readonly trigger = input.required<TemplateRef<unknown>>({ alias: 'mlDialogTrigger' });

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly _opened = signal(false);

  readonly opened = this._opened.asReadonly();

  constructor() {
    const observer = new MutationObserver(() => {
      this._opened.set(this.elementRef.nativeElement.hasAttribute('data-press'));
    });

    observer.observe(this.elementRef.nativeElement, {
      attributes: true,
      attributeFilter: ['data-press'],
    });

    inject(DestroyRef).onDestroy(() => observer.disconnect());
  }
}
